export function formatString(toFormat: string): string {
    if (!toFormat) { return ''; }
    return toFormat.split(' ').reduce((formatted, value) => formatted + (/([\d])\w+/.test(value) ? value : value.toLowerCase()) + ' ', '');
}
